<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>
          Intern Management
        </h1>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-results-details">
        <div class="row">
          <div class="col-xs-12 col-sm-4">
            <router-link :to="{ name: 'intern.create' }" class="btn btn-sm btn btn-primary"><i class="fa fa-plus"></i> Add Intern</router-link>
          </div>
        </div>
      </div>

      <div class="dashboard-block">
        <pickstar-loading v-if="fetchingInterns" class="m-t-lg"/>

        <no-results v-else-if="haveNoInterns">
          There are no interns.
        </no-results>

        <ul v-else class="item-detail item-detail-profile">
          <system-intern-management-list-item
            v-for="intern in interns"
            :key="intern.id"
            :intern="intern"/>
        </ul>

        <lazy-loading
          class="text-center"
          :loading="loading"
          :reached-bottom="handleGetNextInternsCallback"
          ref="lazyLoading">
          <pickstar-loading slot="loading"/>
          <span slot="finished"></span>
        </lazy-loading>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { assign } from 'lodash'
import { handleServerErrors, fetchResourceScope } from 'mixins'
import LazyLoading from 'codium-lazy-loading'
import SystemInternManagementListItem from './SystemInternManagementListItem'

export default {
  mixins: [handleServerErrors, fetchResourceScope],

  props: {
    status: {
      required: false,
      default: 'all'
    }
  },

  computed: {
    ...mapState('intern', ['interns', 'pagination']),
    ...mapState('app', ['loading']),

    queryParams () {
      let params = {
        status: this.$userIsAdmin
          ? this.status
          : 'all'
      }

      return params
    },

    haveNoInterns () {
      return this.interns.length === 0
    }
  },

  components: {
    SystemInternManagementListItem,
    LazyLoading
  },

  data () {
    return {
      searchName: null,
      fetchingInterns: false
    }
  },

  beforeDestroy () {
    this.resetInterns()
  },

  watch: {
    '$route' () {
      this.resetInterns()

      this.fetchingInterns = true

      this.getInterns(this.queryParams)
        .then(() => {
          this.$nextTick(() => {
            if (!this.$refs.lazyLoading) {
              return
            }

            this.$refs.lazyLoading.$emit('reset')
          })
        })
        .catch(this.handleServerErrorsCallback)
        .finally(() => {
          this.fetchingInterns = false
        })
    }
  },

  created () {
    this.searchName = this.$route.query.name || null

    this.getInterns(this.queryParams)
      .catch(this.handleServerErrorsCallback)

    this.getInternCounts(this.queryParams)
      .catch(this.handleServerErrorsCallback)
  },

  methods: {
    ...mapActions('intern', ['getInterns', 'getNextInterns', 'getInternCounts', 'resetInterns']),

    handleNameSearchCallback () {
      let query = assign({}, this.$route.query)

      if (this.searchName) {
        query.name = this.searchName
      } else {
        delete query.name
      }

      this.$router.push({ query })

      return Promise.resolve()
    },

    handleGetNextInternsCallback () {
      return this.getNextInterns(this.queryParams)
    },

    classForStatus (status) {
      if (this.status === status) {
        return 'active'
      }

      return ''
    }
  }
}
</script>
